import React from 'react';

import SmartLink from 'Shared/components/SmartLink';

import OnedriveLogo from 'Shared/images/OneDriveLogo.svg';
import MsWordLogo from 'Shared/images/AttachmentTypesIcons/msword.svg';
import MsExcelLogo from 'Shared/images/AttachmentTypesIcons/msexcel.svg';
import MsPptLogo from 'Shared/images/AttachmentTypesIcons/msppt.svg';
import OnedriveSmartMenu from '../SmartMenu/OnedriveSmartMenu';
import { SmartLinkLogo, SmartLinkContainer } from '../components';

type Props = {
  children: React.ReactNode;
};

const OnedriveLink = ({ children, ...restProps }: Props) => {
  const fileExtension = (restProps as any)?.decoratedText?.split('.')?.slice(-1)?.[0];
  const logoToUse = () => {
    switch (fileExtension) {
      case 'xlsx':
      case 'xls':
        return MsExcelLogo;
      case 'docx':
      case 'doc':
        return MsWordLogo;
      case 'pptx':
      case 'ppt':
        return MsPptLogo;
      default:
        return OnedriveLogo;
    }
  };
  const typeToUse = () => {
    switch (fileExtension) {
      case 'xlsx':
      case 'xls':
        return 'Excel Spreadsheet';
      case 'docx':
      case 'doc':
        return 'Word Document';
      case 'pptx':
      case 'ppt':
        return 'Powerpoint Presentation';
      default:
        return 'OneDrive / SharePoint File';
    }
  };
  return (
    <SmartLinkContainer contentEditable={false}>
      <OnedriveSmartMenu type={typeToUse()} logoName={logoToUse()} {...restProps}>
        <SmartLink {...restProps}>
          <SmartLinkLogo src={logoToUse()} />
          {children}
        </SmartLink>
      </OnedriveSmartMenu>
    </SmartLinkContainer>
  );
};

export default OnedriveLink;
